import { Inject, Injectable } from '@angular/core';

import { BehaviorSubject, from } from 'rxjs';
import { share } from 'rxjs/operators';

import {
  SPRITE_CONFIG_TOKEN,
  SpriteConfig,
} from './model/sprite-config.interface';

/**
 * Svg icons sprite loader service
 */
@Injectable()
export class SvgSpriteService {
  private readonly spriteSubject = new BehaviorSubject<string>('');

  readonly sprite$ = from(this.config.asyncSprite()).pipe(
    share({
      connector: () => this.spriteSubject,
    }),
  );

  constructor(
    @Inject(SPRITE_CONFIG_TOKEN) private readonly config: SpriteConfig,
  ) {}
}
